import { Patient } from "@/types/users";

export default class UserState {
  [key: string]: string | boolean | Patient;
  public timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  public patient: Patient = {
    id: "",
    practitioner: {
      id: "",
      slots: [],
    },
  };
}
